import React, { useState } from "react";
import StatusBadge from "./StatusBadge";
import ScoreBar from "./ScoreBar";

function fmt(n, dec = 2) {
  if (n == null || isNaN(n)) return "—";
  return Number(n).toLocaleString("en-IN", { minimumFractionDigits: dec, maximumFractionDigits: dec });
}

export default function StockRow({ stock, capital }) {
  const [expanded, setExpanded] = useState(false);

  const riskPct = capital > 0 && stock.Actual_Risk_1R
    ? ((stock.Actual_Risk_1R / capital) * 100).toFixed(2)
    : null;

  return (
    <>
      <tr
        onClick={() => setExpanded(!expanded)}
        style={{
          cursor: "pointer",
          borderBottom: "1px solid #f3f4f6",
          background: expanded ? "#f9fafb" : "white",
          transition: "background 0.1s"
        }}
      >
        <td style={{ padding: "8px 12px", fontWeight: 600, fontSize: 13, color: "#111827", whiteSpace: "nowrap" }}>
          {stock.Symbol}
          {stock.NR7 && <span style={{ marginLeft: 4, fontSize: 9, color: "#7c3aed", fontWeight: 700 }}>NR7</span>}
          {stock.Inside_Bar && <span style={{ marginLeft: 4, fontSize: 9, color: "#0891b2", fontWeight: 700 }}>IB</span>}
        </td>
        <td style={{ padding: "8px 8px" }}>
          <StatusBadge status={stock.Status} />
        </td>
        <td style={{ padding: "8px 8px" }}>
          <ScoreBar
            score={stock.Score || 0}
            trend={stock.Trend_Score || 0}
            momentum={stock.Momentum_Score || 0}
            volume={stock.Volume_Score || 0}
            structure={stock.Structure_Score || 0}
            rr={stock.RR_Score || 0}
          />
        </td>
        <td style={{ padding: "8px 8px", fontSize: 13, textAlign: "right", fontFamily: "monospace" }}>
          {fmt(stock.Close)}
        </td>
        <td style={{ padding: "8px 8px", fontSize: 13, textAlign: "right", fontFamily: "monospace" }}>
          {fmt(stock.Entry)}
        </td>
        <td style={{ padding: "8px 8px", fontSize: 13, textAlign: "right", fontFamily: "monospace", color: "#dc2626" }}>
          {fmt(stock.SL)}
        </td>
        <td style={{ padding: "8px 8px", fontSize: 13, textAlign: "right", fontFamily: "monospace", color: "#16a34a" }}>
          {fmt(stock.T1)}
        </td>
        <td style={{ padding: "8px 8px", fontSize: 13, textAlign: "right", fontFamily: "monospace", color: "#15803d" }}>
          {fmt(stock.T2)}
        </td>
        <td style={{ padding: "8px 8px", fontSize: 12, textAlign: "right", color: "#6b7280" }}>
          {fmt(stock.RR_Ratio, 1)}x
        </td>
        <td style={{ padding: "8px 8px", fontSize: 11, color: "#6b7280", textAlign: "center" }}>
          {stock.Weekly_Uptrend ? "↑" : "↓"}
        </td>
      </tr>
      {expanded && (
        <tr style={{ background: "#f9fafb" }}>
          <td colSpan={10} style={{ padding: "12px 16px" }}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16 }}>

              {/* Entry details */}
              <div>
                <div style={{ fontSize: 11, fontWeight: 600, color: "#6b7280", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.05em" }}>Trade Setup</div>
                <div style={{ fontSize: 12, display: "flex", flexDirection: "column", gap: 3 }}>
                  <div>Entry: <strong>{fmt(stock.Entry)}</strong></div>
                  <div>Stop Loss: <strong style={{ color: "#dc2626" }}>{fmt(stock.SL)}</strong> ({stock.SL_Method})</div>
                  <div>T1: <strong style={{ color: "#16a34a" }}>{fmt(stock.T1)}</strong></div>
                  <div>T2: <strong style={{ color: "#15803d" }}>{fmt(stock.T2)}</strong></div>
                  <div>Risk: <strong>{fmt(stock.Actual_Risk_1R, 0)} {riskPct ? `(${riskPct}%)` : ""}</strong></div>
                  <div>Shares: <strong>{stock.Shares || 0}</strong></div>
                </div>
              </div>

              {/* Indicators */}
              <div>
                <div style={{ fontSize: 11, fontWeight: 600, color: "#6b7280", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.05em" }}>Indicators</div>
                <div style={{ fontSize: 12, display: "flex", flexDirection: "column", gap: 3 }}>
                  <div>RSI(14): <strong>{fmt(stock.RSI_14, 1)}</strong></div>
                  <div>ADX: <strong>{fmt(stock.ADX, 1)}</strong></div>
                  <div>RS vs Index: <strong>{fmt(stock.RS, 2)}</strong></div>
                  <div>Ratio1: <strong>{fmt(stock.Ratio1, 2)}</strong></div>
                  <div>Ratio2: <strong>{fmt(stock.Ratio2, 2)}</strong></div>
                  <div>TRP: <strong>{fmt(stock.TRP, 4)}</strong></div>
                </div>
              </div>

              {/* Reason and action */}
              <div>
                <div style={{ fontSize: 11, fontWeight: 600, color: "#6b7280", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.05em" }}>Signal</div>
                <div style={{ fontSize: 11, color: "#374151", lineHeight: 1.5, marginBottom: 8 }}>
                  {stock.Reason}
                </div>
                <div style={{ fontSize: 11, fontWeight: 600, color: "#1d4ed8", lineHeight: 1.5 }}>
                  → {stock.Next_Action}
                </div>
                {stock.Friday_Caution && (
                  <div style={{ marginTop: 6, fontSize: 11, color: "#b45309" }}>⚠ Friday — higher score threshold applied</div>
                )}
                {stock.Soft_Flag === "YES" && (
                  <div style={{ marginTop: 4, fontSize: 11, color: "#dc2626" }}>⚠ Data flag — verify before trading</div>
                )}
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
}
